import {Http} from '../../../Data/config/Http';
import {Tag} from '../models/tag.model';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

export const ProductTagAPIDataSource = {
  getTags: async (): Promise<Tag[]> => {
    try {
      const response = await Http.get<BaseResponse<Tag[]>>(API_ROUTES.PRODUCTS.TAGS);
      return unwrapResponse(response.data, 'حدث خطأ في جلب العلامات');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  createTag: async (payload: { name: string }): Promise<Tag> => {
    try {
      const response = await Http.post<BaseResponse<Tag>>(API_ROUTES.PRODUCTS.TAGS, payload);
      return unwrapResponse(response.data, 'فشل في إضافة العلامة', [200, 201]);
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  updateTag: async (id: number, payload: { name: string }): Promise<Tag> => {
    try {
      const response = await Http.put<BaseResponse<Tag>>(API_ROUTES.PRODUCTS.TAG_BY_ID(id.toString()), payload);
      return unwrapResponse(response.data, 'فشل في تعديل العلامة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  deleteTag: async (id: number): Promise<void> => {
    try {
      const response = await Http.delete<BaseResponse<void>>(API_ROUTES.PRODUCTS.TAG_BY_ID(id.toString()));
      unwrapResponse(response.data, 'فشل في حذف العلامة', [200, 204]);
    } catch (error) {
      handleDataSourceError(error);
    }
  }
};

